import { api } from "./api";
import type { Renditebruecke } from "./otterfolio";

export interface WatchlistItemDto {
  id: string;
  symbol: string;
  isin: string | null;
  name: string;
  currency: string;
  investmentCategory: "FELS" | "RAKETE" | null;
  addedAt: string;
  notes: string | null;
  isActive: boolean;
  growthEstimatePercent: number | null;
  payoutYieldPercent: number | null;
  valuationDeltaPercent: number | null;
  renditebrueckeUpdatedAt: string | null;
  currentPriceCents: number | null;
  currentPriceAsOf: string | null;
  quotesSparkline: number[];
}

export interface WatchlistQuotePoint {
  asOf: string;
  priceCents: number;
}

export interface WatchlistItemDetailDto extends WatchlistItemDto {
  quotes: WatchlistQuotePoint[];
  renditebruecke: Renditebruecke | null;
}

export async function fetchWatchlistItem(id: string): Promise<WatchlistItemDetailDto> {
  return api<WatchlistItemDetailDto>(`/watchlist/${id}`);
}

export async function createWatchlistItem(body: {
  symbol: string;
  name: string;
  currency: string;
  isin?: string | null;
  investmentCategory?: "FELS" | "RAKETE" | null;
  notes?: string | null;
}): Promise<WatchlistItemDto> {
  return api<WatchlistItemDto>("/watchlist", { method: "POST", body });
}

export async function updateWatchlistItem(
  id: string,
  body: Partial<WatchlistItemDto>,
): Promise<WatchlistItemDto> {
  return api<WatchlistItemDto>(`/watchlist/${id}`, { method: "PATCH", body });
}

export async function deleteWatchlistItem(id: string): Promise<void> {
  return api<void>(`/watchlist/${id}`, { method: "DELETE" });
}

export async function refreshWatchlistQuote(id: string): Promise<WatchlistItemDetailDto> {
  return api<WatchlistItemDetailDto>(`/watchlist/${id}/refresh`, { method: "POST" });
}

export async function promoteWatchlistToInvestment(id: string): Promise<{ investmentId: string }> {
  return api<{ investmentId: string }>(`/watchlist/${id}/promote-to-investment`, {
    method: "POST",
  });
}
